import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import Loader from '../Loader/Loader';
import Sanitize from '../Sanitize';
import ViewStudentResult from './ViewStudentResult';
import Pagination from "react-js-pagination";

class ViewResult extends Component {
	
	constructor(props){
        super(props);
		this.state = {
            data : [],
            exam : this.props.exam,
            acyear : this.props.acyear,
            currentPage: 1,
			todosPerPage: 10,
			activePage : 1,
            loading : false,
            showmodal : false,
        }
        this.handlePageChange = this.handlePageChange.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}

    toggle(e){
        this.setState({showmodal : !this.state.showmodal});
    }

    onViewClick(regno,stdname){
        this.setState({regno : regno,stdname : stdname,showmodal : !this.state.showmodal});
    }

    componentDidMount(){
        this.getstudents();
    }
    
	getstudents(){
		this.setState({loading : true});
		GetData('question/getstudentsbyexam/'+this.state.acyear+'/'+this.state.exam).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
                    data : responseJson,
                    acyear : responseJson[0].acyear,
                    examname : responseJson[0].examname,
                    examdate : responseJson[0].examdate,
                    fromtime : responseJson[0].fromtime,
                    totime : responseJson[0].totime,
                    sec : responseJson[0].sec,
                    noofmarks : responseJson[0].noofmarks,
                    totalmarks : responseJson[0].totalmarks,
                    selection : responseJson[0].selection,
                    less : responseJson[0].lesson,
                    subname : responseJson[0].subname,
                    clsname : responseJson[0].cls,
                    loading : false
                });
			}
		});
	}
    
    render() {

        // Logic for displaying current todos
        const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        const currentTodos = this.state.data.slice(indexOfFirstTodo, indexOfLastTodo);

        const renderTodos = currentTodos.map((item,i) => {
            return <tr>
                <td>{i+1}</td>
                <td>{item.stdname}</td>
                <td>{item.mark}</td>
                <td>{item.mark == null ? <b className="text-danger">Not Attended</b> : <b className="text-success">Attended</b>}</td>
                <td>
                    {item.mark == null ? '' : 
                    <button className="btn btn-warning btn-sm" onClick={this.onViewClick.bind(this,item.regno,item.stdname)}><i className="fa fa-eye"></i></button>}
                </td>
            </tr>;
        });
    
        if (this.state.loading) {
			return (
				<Loader />
			)
		} else {
        return (<div>
            <Row>
                <Col md={12}>
                    <table width="100%">
                        <tbody>
                            <tr>
                                <td align="left">Class : <b>{this.state.clsname} - {this.state.sec}</b></td>
                                <td align="center">Exam Name : <b>{this.state.examname}</b></td>
                                <td align="right">Subject : <b>{this.state.subname}</b></td>
                            </tr>
                            <tr>
                                
                                <td align="left">Date : <b>{Sanitize.dmyDash(this.state.examdate)}</b><br />
                                    Time : <b>{this.state.fromtime} to {this.state.totime}</b>
                                </td>
                                <td colSpan="2" align="right">No.of Questions : <b>{this.state.totalmarks/this.state.noofmarks}</b><br />
                                    Total Marks : <b>{parseFloat(this.state.totalmarks)}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table><br />
                    <b style={{float : 'right'}}>No of Students : {this.state.data.length}</b>
                    <Table bordered responsive>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Student Name</th>
                                <th>Mark</th>
                                <th>Status</th>
                                <th>Manage</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderTodos}
                        </tbody>
                    </Table>
                    <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={this.state.todosPerPage}
                            pageRangeDisplayed={3}
                            totalItemsCount={this.state.data.length}
                            onChange={this.handlePageChange}
                        />
                    <Modal isOpen={this.state.showmodal} size="lg" toggle={this.toggle} className={this.props.className}>
                        <ModalHeader toggle={this.toggle}>View Result - {this.state.stdname} ({this.state.regno})</ModalHeader>
                        <ModalBody>
                            <ViewStudentResult acyear={this.state.acyear} exam={this.state.exam} regno={this.state.regno} stdname={this.state.stdname} />
                        </ModalBody>
                    </Modal>
                </Col>
            </Row>
        </div>)
        }
    }
}

export default ViewResult;



// WEBPACK FOOTER //
// ./src/Questions/ViewResult.js